export default __webpack_public_path__ + "static/media/AwaitingReportUploadCloud.f2a29286.svg";